var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-page__block months-dashboard"},[_c('div',{staticClass:"chart-title"},[_vm._v(_vm._s(_vm.chartTitle[_vm.chartType]))]),_c('div',{staticClass:"months-dashboard__chart"},[_c('div',{class:_vm.apexChartName})])])
}
var staticRenderFns = []

export { render, staticRenderFns }